<script setup lang="ts">
import type { IWidgetStaff } from './types'
import { UserRound } from 'lucide-vue-next'

const props = withDefaults(defineProps<IWidgetStaff>(), {
  variant: 'white',
  hideContacts: false,
  showNews: false
})
</script>

<template>
  <div
    class="flex h-full flex-col justify-between rounded-lg p-4"
    :class="props.variant === 'white' ? 'bg-white' : 'bg-gray-100'"
  >
    <div class="flex items-center gap-2">
      <NuxtImg
        v-if="props.photo"
        :src="props.photo"
        :alt="props.fullname"
        width="168"
        height="168"
        format="avif,webp"
        class="mr-4 h-14 w-14 rounded-[6px] transition-transform duration-300 hover:z-10 hover:scale-[3] hover:rounded-[4px]"
      />
      <div
        v-else
        class="mr-4 flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-white"
      >
        <UserRound />
      </div>
      <div class="flex flex-col gap-0.5">
        <div class="font-serif font-bold leading-4">{{ props.fullname }}</div>
        <div v-if="props.position" class="mt-1 text-sm leading-3 text-gray-700">
          {{ props.position }}
        </div>
      </div>
    </div>
  </div>
</template>
